import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {
  TdDataTableService,
  TdDataTableSortingOrder,
  ITdDataTableSortChangeEvent,
  ITdDataTableColumn,
  TdDialogService,
  IPageChangeEvent
} from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { InventoryService } from '../../../inventory/inventory.service';
import { SettingsService } from '../../../../shared/services/settings.service';
import { Utils } from '../../../../shared/utils';

@Component({
  selector: 'app-find-product',
  templateUrl: './find-product.component.html',
  styleUrls: ['./find-product.component.scss']
})
export class InvFindProductComponent implements OnInit {
  title: string;
  pieceNumber: any;
  products: any[] = [];

  color_id: string;

  columns: ITdDataTableColumn[] = [
    { name: 'piece_number', label: 'Piece Number', tooltip: '' },
    { name: 'collection_name', label: 'Collection', tooltip: '' },
    { name: 'design_name', label: 'Design', tooltip: '' },
    { name: 'name', label: 'Color', tooltip: '' },
    { name: 'grade_code', label: 'Grades' },
    { name: 'length', label: 'Qty' },
    { name: 'branch', label: 'Branch' },
    { name: 'location_name', label: 'Location' }
  ];

  filteredData: any[];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;

  constructor(private _dialogService: TdDialogService,
    private _dataTableService: TdDataTableService,
    public _settingsService: SettingsService,
    private location: Location,
    public _authService: AuthenticationService,
    private _inventoryService: InventoryService,
  ) { }

  ngOnInit(): void {
  }

  goBack(): void {
    this.location.back();
  }

  /*changeLocation(): void {
    this._dialogService.openAlert({
      message: 'There is no such piece' + (this.pieceNumber ? ' ' + this.pieceNumber : '') + '!',
      title: 'Error'
    });
  }*/

  getUnit(unit_type: string) {
    switch (unit_type) {
      case 'LENGTH': {
        return ' (m)';
      }
      case 'AREA': {
        return ' (m²)';
      }
      default: {
        // none
        return ' (pcs)';
      }
    }
  }

  getLengthString(amount: number, unit_type: string) {

    switch (unit_type) {
      case 'LENGTH': {
        return amount + 'm (' + amount * 1.09361 + 'y)';
      }
      case 'AREA': {
        return amount + 'm² (' + amount * 10.7639 + 'SqFt)';
      }
      default: {
        // none
        return amount + ' (pcs)';
      }
    }

  }

totalPieces() {
  return this.products.length;
}

totalMeters() {
  return this.products.reduce((a, b) => { return a * 1 + b['length'] * 1 }, 0);
}

sort(sortEvent: ITdDataTableSortChangeEvent): void {
  this.sortBy = sortEvent.name;
  this.sortOrder = sortEvent.order;
  this.filter();
}

/*findProduct(pieceNumber: string): void {
  this.searchTerm = pieceNumber;
  this.filter();
}*/
findProduct(color_id: string): void {
  this._inventoryService.findProduct(color_id).subscribe(
    response => {
      this.products = response;
      this.filter();
    }
  );
}

page(pagingEvent: IPageChangeEvent): void {
  this.fromRow = pagingEvent.fromRow;
  this.currentPage = pagingEvent.page;
  this._settingsService.setPageSize(pagingEvent.pageSize);
  this.filter();
}

filter(): void {
  let newData: any[] = this.products;
  let excludedColumns: string[] = this.columns
    .filter((column: ITdDataTableColumn) => {
      return ((column.filter === undefined && column.hidden === true) ||
        (column.filter !== undefined && column.filter === false));
    }).map((column: ITdDataTableColumn) => {
      return column.name;
    });

  newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
  this.filteredTotal = newData.length;
  newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
  if(this._settingsService.getPageSize() + '' != 'All') {
  newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
}
this.filteredData = newData;

if (this.filteredTotal < 1) {
  this._dialogService.openAlert({
    message: 'No pieces found for that product!',
    title: 'Error'
  });
}
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/inventory/find-product/find-product.component.ts